import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const GetUnidadesMedida = ()  => {
    const api = useApi();

    const mutate = async () => {
        const data  = await api.get(`/unidades-medidas`);
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        getUnidadesMedidaMutation: mutation.mutate,
    };
}